import React from 'react';
import { Result, Button } from 'antd';

import { GlobalStore } from 'stores/Global';
import { ResetView } from 'components/Reset/ResetView';
import { ResetModel } from 'components/Reset/ResetModel';
import { useRouteMatch } from 'react-router-dom';

export const ResetRoute = () => {
  const { params }: { params: { token?: string } } = useRouteMatch();

  if (!params.token) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, we cannot find page you're looking for."
        extra={
          <Button type="primary" onClick={() => GlobalStore.navigate('/')}>
            Back Home
          </Button>
        }
      />
    );
  }

  const model = new ResetModel(params.token);

  return (
    <ResetView model={model} />
  );
};